import React from "react";
const SidebarCollapse = ({style = {}, size = "36", className = "", fill = "#73788B", stroke = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect className="u_stroke" x={3.25} y={5.25} width={29.5} height={25.5} rx={4} stroke={stroke} strokeWidth={2.5}/>
        <path className="u_stroke" d="M13.5 5.5v25" stroke={stroke} strokeWidth={2.5}/>
        <path className="u_stroke" d="M26 13.25 21.25 18 26 22.75" stroke={stroke} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
export default SidebarCollapse;
